import * as S from "./ChristmasBanner.styles";
import BannerBgMp4 from "./assets/banner-bg.mp4";
import BannerBgJpg from "./assets/banner-bg.jpg";
import BannerBgMobileMp4 from "./assets/banner-bg-mobile.mp4";
import BannerBgMobileJpg from "./assets/banner-bg-mobile.jpg";

import { useTranslation } from "hooks/useTranslation";
import { useSiteSettings } from "context/SiteSettingsContext";
import { BREAKPOINTS } from "layout";
import { useMedia } from "react-use";
import { BottomBanner } from "components/BottomBanner";

const CHRISTMAS_PROMO_COOKIE_NAME = "ui_cp_closed";

export const ChristmasBanner = () => {
  const isMobile = useMedia(BREAKPOINTS.TABLET_AND_DOWN);
  const { routes } = useSiteSettings();

  const { t } = useTranslation();

  return (
    <BottomBanner
      href={routes.store.christmasCampaign()}
      cookieName={CHRISTMAS_PROMO_COOKIE_NAME}
      backgroundColor="#071221"
      disabledStores={[]}
    >
      {isMobile ? (
        <S.StyledMobileVideo
          src={BannerBgMobileMp4}
          poster={BannerBgMobileJpg}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <S.StyledVideo
          src={BannerBgMp4}
          poster={BannerBgJpg}
          autoPlay
          muted
          loop
          playsInline
        />
      )}

      <S.TextContainer>
        <S.Title>{t("christmas.banner.title")}</S.Title>
        <S.Description>{t("christmas.banner.description")}</S.Description>
        <S.Disclaimer
          dangerouslySetInnerHTML={{ __html: t("christmas.banner.disclaimer") }}
        />
      </S.TextContainer>
    </BottomBanner>
  );
};
